
import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000/api';

const reportService = {
  /**
   * Submit a report for a project
   * @param {string} projectId - ID of the project to report
   * @param {Object} reportData - { reason, details }
   * @returns {Promise}
   */
  submitReport: async (projectId, reportData) => {
    try {
      const response = await axios.post(`${API_URL}/projects/${projectId}/report`, reportData, {
        withCredentials: true
      });
      return response.data;
    } catch (error) {
      throw error.response?.data?.error || error;
    }
  },

  /**
   * Get report summary for a project owner
   * @param {string} projectId - ID of the project
   * @returns {Promise}
   */
  getOwnerReportSummary: async (projectId) => {
    try {
      const response = await axios.get(`${API_URL}/projects/${projectId}/owner-reports`, {
        withCredentials: true
      });
      return response.data;
    } catch (error) {
      throw error.response?.data?.error || error;
    }
  },

  /**
   * Admin: Get all reported projects
   * @returns {Promise}
   */
  getAdminReportedProjects: async () => {
    try {
      const response = await axios.get(`${API_URL}/admin/reports`, {
        withCredentials: true
      });
      return response.data;
    } catch (error) {
      throw error.response?.data?.error || error;
    }
  },

  /**
   * Admin: Get specific project reports
   * @param {string} projectId 
   * @returns {Promise}
   */
  getAdminProjectReports: async (projectId) => {
    try {
      const response = await axios.get(`${API_URL}/admin/reports/${projectId}`, {
        withCredentials: true
      });
      return response.data;
    } catch (error) {
      throw error.response?.data?.error || error;
    }
  },

  /**
   * Admin: Dismiss reports for a project
   * @param {string} projectId 
   * @returns {Promise}
   */
  dismissReports: async (projectId) => {
    try {
      const response = await axios.post(`${API_URL}/admin/reports/${projectId}/dismiss`, {}, {
        withCredentials: true
      });
      return response.data;
    } catch (error) {
      throw error.response?.data?.error || error;
    }
  }
};

export default reportService;
